(function () {
  // Filtrado por categoría desde un link externo (ej. un tag pegado en
  // el contenido de un artículo, que apunta de vuelta acá con
  // ?tag=Nombre). Si el parámetro está presente, oculta todas las
  // tarjetas que no coincidan con esa categoría, dejando solo las que
  // sí — sin depender de la ruta nativa /tagged/ de Shopify (que usa
  // una plantilla sin el diseño del proyecto).
  function initTagFilter(section) {
    var params = new URLSearchParams(window.location.search);
    var requestedTag = params.get('tag');
    if (!requestedTag) return;

    var cards = Array.prototype.slice.call(
      section.querySelectorAll('[data-recipes-blog-lola-card]')
    );
    if (!cards.length) return;

    var normalizedRequested = requestedTag.trim().toLowerCase();
    var matchCount = 0;

    cards.forEach(function (card) {
      var cardTag = (card.getAttribute('data-recipe-tag') || '').trim().toLowerCase();
      var matches = cardTag === normalizedRequested;
      card.hidden = !matches;
      if (matches) matchCount += 1;
    });

    // Si ningún artículo coincide (ej. el tag ya no existe, o hubo un
    // error de tipeo), se muestran todas las tarjetas de nuevo en vez
    // de dejar la grilla completamente vacía sin explicación.
    if (matchCount === 0) {
      cards.forEach(function (card) {
        card.hidden = false;
      });
      return;
    }

    // Lleva la vista directo a la grilla ya filtrada, en vez de que el
    // visitante aterrice arriba de la página y tenga que buscarla.
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.querySelectorAll('[data-recipes-blog-lola]').forEach(function (section) {
    initTagFilter(section);
  });
})();